/**
 * 消防文件管理路由配置
 */
const fireFileRoute = {
  path: 'firefile',
  name: 'firefile',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'fireFileList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '消防文件管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default fireFileRoute;
